module.exports = __webpack_public_path__ + "static/media/ninth_newpaper_plant4.31e358bf.png";